import React from 'react';
import styled from '@emotion/styled';
import { fontSize, spacing, mediaMax } from 'presentations/views/styles';
import { black, gray04, gray05, white } from 'presentations/views/styles/color';
import Link from 'presentations/views/components/atoms/Link';
import { translate } from 'infras/i18n';
import Breadcrumb from 'presentations/routes/breadcrumb';
import Breadcrumbs from '@mui/material/Breadcrumbs';

interface Props {
  routes?: Breadcrumb[];
}

export default function Component({ routes }: Props) {
  if (!routes) return null;
  return (
    <Container>
      <Styled separator="/" aria-label="breadcrumb">
        <StyledLink href="/">{translate('siteName')}</StyledLink>
        {routes.map((route, index) =>
          route.link ? (
            <StyledLink key={index} href={route.link}>
              {route.title}
            </StyledLink>
          ) : (
            <span key={index}>{route.title}</span>
          ),
        )}
      </Styled>
    </Container>
  );
}

const Styled = styled(Breadcrumbs)`
  * {
    font-size: ${fontSize(11)};
  }
  a {
    &:hover {
      text-decoration: none;
    }
  }
  span {
    color: ${black};
  }
`;
const StyledLink = styled(Link)`
  color: ${black};
`;

const Container = styled.div`
  padding: ${spacing(8)} ${spacing(16)};
  ${mediaMax.tablet} {
    display: none;
  }
  border-bottom: 1px solid ${gray04};
`;
